import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterAct'
})
export class FilterActPipe implements PipeTransform {

  transform(
    actes: any[], 
    searchText?: string, 
    familleActe?: string
  ): any[] {
    
    if (!actes) return [];
    
    let actesFiltres = actes;

    if (familleActe) {
      actesFiltres = actesFiltres.filter(act => 
        act.actes?.famille_Acte?.toLowerCase() === familleActe.toLowerCase()
      );
    }

    if (searchText) {
      const searchTerm = searchText.toLowerCase();
      actesFiltres = actesFiltres.filter(act => 
        act.actes?.desc_Acte?.toLowerCase().includes(searchTerm) ||
        act.actes?.cnam_ACT_COD?.toLowerCase().includes(searchTerm) ||
        act.actes?.priseenCharge_Acte?.toLowerCase().includes(searchTerm) ||
        act.actes?.act_LIB_USE?.toLowerCase().includes(searchTerm) ||
        act.actes?.famille_Acte?.toLowerCase().includes(searchTerm)
      );
    }

    return actesFiltres;
  }
}